import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import changeset from 'ember-changeset/helpers/changeset';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import Formy from 'parog-web/components/formy';
import type FormyController from 'parog-web/test-routes/formy/controller';

const FormyTestRoute: TOC<{ Args: { controller: FormyController } }> =
  <template>
    <LinkTo data-test-index-link @route='index'>Home</LinkTo>

    <Formy
      @changeset={{changeset @controller.model}}
      @onSuccess={{@controller.transitionToIndex}}
      as |f|
    >
      <button
        data-test-set-name
        type='button'
        {{on 'click' (fn (changesetSet f.changeset 'name') 'John Doe')}}
      >Click me to make a change</button>
      <f.Actions />
    </Formy>
  </template>;

export default FormyTestRoute;
